import { useState } from 'react';
import { SectionHeading } from './SectionHeading';
import { Typography } from './Typography';
import { Button } from './Button';
import { WorkflowVisual } from './WorkflowVisual';
import { process } from '../content/site';
import styles from './ProcessSection.module.css';
export function ProcessSection() {
  const [active, setActive] = useState(0);
  const p = process[active];
  return (
    <section className={styles.section}>
      <SectionHeading eyebrow="Как мы работаем" title="Системный подход на каждом этапе" />
      <div className={styles.tabs} role="tablist" aria-label="Этапы работы">
        {process.map((x, i) => (
          <button
            key={x.name}
            id={`process-tab-${i}`}
            role="tab"
            aria-selected={active === i}
            aria-controls="process-panel"
            tabIndex={active === i ? 0 : -1}
            onClick={() => setActive(i)}
            onKeyDown={(e) => {
              let n = active;
              if (e.key === 'ArrowRight') n = (active + 1) % 3;
              else if (e.key === 'ArrowLeft') n = (active + 2) % 3;
              else if (e.key === 'Home') n = 0;
              else if (e.key === 'End') n = 2;
              else return;
              e.preventDefault();
              setActive(n);
              document.getElementById(`process-tab-${n}`)?.focus();
            }}
            className={active === i ? styles.active : ''}
          >
            <Typography as="span" variant="tab" tone="inherit">
              {x.name}
            </Typography>
          </button>
        ))}
      </div>
      <div
        className={styles.panel}
        id="process-panel"
        role="tabpanel"
        aria-labelledby={`process-tab-${active}`}
      >
        <WorkflowVisual steps={p.steps} result={p.result} />
        <div className={styles.copy}>
          <Typography variant="eyebrow" tone="muted">{`0${active + 1} — ${p.name}`}</Typography>
          <Typography as="h3" variant="title">
            {p.title}
          </Typography>
          <Typography tone="muted">{p.description}</Typography>
          <Button href="/contact/">Обсудить проект</Button>
          <Typography variant="small" tone="muted">
            От планирования до презентации результатов
          </Typography>
        </div>
      </div>
    </section>
  );
}
